<template>
    <div class="card-list-wrapper" :class="{'mobile': getMobileAppState}">
        <div class="title">{{t('payments.services.frequentPayments')}}</div>
        <div v-if="!getMobileAppState" class="card-list-wrapper">
            <div v-if="!applyErrorState && frequentOperationsParse.length" class="cards-wrapper">
                <payment-card
                v-for="paymentInfo in frequentOperationsParse"
                :key="paymentInfo.operation.id"
                :paymentInfo="paymentInfo"
                :paymentsOperatorsList="getPaymentsOperatorsList"
                @cardClicked="emit('cardClicked', paymentInfo)"/>
            </div>
            <empty-state-error v-else :message="t('payments.services.frequentPaymentsError')"/>
        </div>
        <!-- Mobile Generic Slider -->
        <slider-generic
        v-else
        :selectedIndex="selectedCard"
        :sliderList="frequentOperationsParse"
        @updateSelectedIndex="selectedCard = $event">
            <payment-card
            v-for="paymentInfo in frequentOperationsParse"
            :key="paymentInfo.operation.id"
            :paymentInfo="paymentInfo"
            :paymentsOperatorsList="getPaymentsOperatorsList"
            @cardClicked="emit('cardClicked', paymentInfo)"/>
        </slider-generic>
    </div>
</template>

<script setup>

import PaymentCard from '@/components/features/payments/services/frequentOperations/PaymentCard'
import EmptyStateError from '@/components/generic/emptyStates/Error'
import SliderGeneric from '@/components/generic/sliders/Generic'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'
import { moduleMapper } from '@/store/helpers/modules.map'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* mapGetters */
const { getPaymentsOperatorsList } = mapGetters(moduleMapper.PAYMENTS_SERVICES)
const { getMobileAppState } = mapGetters()

/* Props
@applyErrorState {Boolean} - Prop to apply Error State
@frequentOperationsParse {Array} -Operations Array
*/
const props = defineProps({
    applyErrorState: Boolean,
    frequentOperationsParse: Array
})

/* Emmitters */
const emit = defineEmits(['cardClicked'])

</script>

<style lang="scss" scoped>
.card-list-wrapper {
    width: 100%;
    padding: 16px;
    gap: 16px;

    display: flex;
    flex-direction: column;

    background-color: var(--secondary-light-4);
    border-radius: 16px;

    .title {
        width: 100%;

        @include H6-Medium;
        color: var(--secondary-dark-1);
    }

    .cards-wrapper {
        width: 100%;
        gap: 8px;

        display: flex;
        flex-wrap: wrap;
    }

    &.mobile {
        padding: 16px 0;

        height: auto;
        background-color: unset;

        .title {
            padding: 0 16px;
        }
    }
}
</style>
